function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "star",
  d: "M65.922,25.251a5.5,5.5,0,0,0-4.361-3.74L45.848,18.958,38.564,4.8a5.518,5.518,0,0,0-9.812,0L21.468,18.958,5.755,21.511a5.518,5.518,0,0,0-3.031,9.33l11.211,11.3L11.508,57.875a5.514,5.514,0,0,0,7.938,5.767l14.213-7.17,14.213,7.17a5.516,5.516,0,0,0,7.938-5.767L53.382,42.142l11.211-11.3a5.5,5.5,0,0,0,1.328-5.589Zm-4.409,2.535L48.761,40.642l2.761,17.9a1.176,1.176,0,0,1-1.7,1.232L33.659,51.613,17.493,59.77a1.176,1.176,0,0,1-1.7-1.232l2.761-17.9L5.805,27.787a1.18,1.18,0,0,1,.648-1.994l17.872-2.905,8.285-16.1a1.178,1.178,0,0,1,2.1,0l8.285,16.1,17.872,2.905a1.18,1.18,0,0,1,.648,1.994Z",
  transform: "translate(-1.126 -1.811)",
  fill: "#ac1ede"
});

var SvgStar = function SvgStar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65.069,
    height: 62.424,
    viewBox: "0 0 65.069 62.424",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/star.7667ea3c.svg";
export { ForwardRef as ReactComponent };